import { initializeApp } from 'firebase/app'
import { addDoc, collection, getDocs, getFirestore, query, serverTimestamp, Timestamp, updateDoc, where } from 'firebase/firestore/lite'
import React, { FC, useEffect } from 'react'
import { useAuth } from '../../../modules/auth'


const ShoppingBasketGamesPageWrapper: FC = () => {
    const firebaseConfig = {
        apiKey: "AIzaSyDnyomA90Kg1yrELokYx02jOHRs_Cm7LGc",
        authDomain: "gj08-6e7ea.firebaseapp.com",
        projectId: "gj08-6e7ea",
        storageBucket: "gj08-6e7ea.appspot.com",
        messagingSenderId: "527457566258",
        appId: "1:527457566258:web:da78475eabd5ae580b062b",
        measurementId: "G-KGVQ6TS2WV"
    };
    // Firebase variables
    const firebaseApp = initializeApp(firebaseConfig);
    const firebaseDB = getFirestore(firebaseApp);
    const { currentUser } = useAuth()

    useEffect(() => {
        // On user Tap to play game a postMessage event will be triggered and on parent app we listen to that event
        window.addEventListener("message", function (e) {
            if(e.data.type === 'play') {
                addUserStarRatingInFirebaseDB('onplay', 5)
            }else if (e.data.type === 'gameOver') {
                isHighScoreCreated(e.data.result)
            }
        })
    })

    const addUserStarRatingInFirebaseDB = async (rewardType:any, score:any) => {
        try {
            // Set start rating into starRatingList colection with primary key as user uid
            const starRatingRef = await addDoc(collection(firebaseDB, "starRatingList"), {
                user_id: currentUser!.id,
                gameName: 'shopping_basket',
                rating: score, // Add 5 rating on each time when user play & Add 10 rating on each time when user create high score
                type: rewardType,
                datetime: Timestamp.fromDate(new Date()).toDate(),
            });
            console.log("Star Rating added in firestore with ID:: ", starRatingRef.id);
        } catch (error) {
            console.error("Error updating Star Rating in firestore: ", error);
        }
    }

    const isHighScoreCreated = async (score: any) => {
        // Check If high score is created, Then update the high score with the new high score and reward user with 10 rating
        try {
            const q = query(collection(firebaseDB, "games"), where("gameName", "==", "shopping_basket"));
            let querySnapshot = await getDocs(q);
            let gameHighScore 
            querySnapshot.forEach( async (game) => {
                gameHighScore = game.data().highScore
                if(score > gameHighScore) {
                    await updateDoc(game.ref, {
                        highScore: score,
                    });
                    addUserStarRatingInFirebaseDB('onHighScore', 10)
                }
            });
        } catch (error) {
            console.error("Error updating high score data in firestore: ", error);
        }
    }

    return (
        <>
            <div className="row mt-4 game-full-screen">
                <iframe title="Shopping Basket" className='responsive-iframe' src="https://shopping-cart-game.netlify.app"></iframe>
            </div>
        </>
    )
}


export { ShoppingBasketGamesPageWrapper }